import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Accor**
 *
 * @exports bs_237
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  let refreshPrice;

  /**
     * @memberOf module:bs_237
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    thn.pageCheck();
  };

  /**
    * @memberOf module:bs_237
    * @see {@link is_user_logged}
    *
    * @param {object} ctx - The context object.
    */
  engine.isUserLogged = function isUserLogged(ctx) {
    const isLogged = !!document.querySelector('.button-logo__button--disconnected');
    return isLogged;
  };

  /**
     * @memberOf module:bs_237
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const $ = window.jQuery;
    const $app = $ && $('#app-main');
    const stopObservation = function () {
      thn.stopObserveDom($app.get(0), thn.accorRoomsObserver);
      // Delete reference to the observer function
      delete thn.accorRoomsObserver;
    };

    if (!thn.accorRoomsObserver && $app && $app.length) {

      thn.accorRoomsObserver = function thnAccorRoomsObserver() {
        if ($app.find('#rooms-content .reborn-price__amount:visible').length) {
          // Stop observation when the first price is visible
          stopObservation();
          // Update PW
          ctx.widget.update();
        }
      };

      thn.observeDom($app.get(0), thn.accorRoomsObserver, {
        childList: true,
        subtree: true,
        characterData: false,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    // Change on the currency selector
    const currencySelectEv = thn.delegate('change', '.rooms__btn-bar__currency__select', function () {
      ctx.widget.logger.debug('Currency changed!');
      setTimeout(() => ctx.widget.refresh(), 200);
    });

    // Setup unload
    thn.pageUnload(function () {
      ctx.widget.logger.debug('Page unload: reset PW!');
      // Stop observation
      stopObservation();
      // Remove event listeners
      currencySelectEv();
      // Unload the PW for proper loading when returning to R&R
      ctx.widget.reset();
    });

    // Version 2
    const resultContainer = document.querySelector('.rooms-list.rooms-list');

    if (resultContainer) {
      refreshPrice = thn.debounce(thn.widgets.price.refresh, 500);

      thn.observeDom(resultContainer, refreshPrice, {
        childList: true,
        subtree: false,
        attributes: true,
      });

      thn.pageUnload(() => {
        refreshPrice.cancel();
        thn.stopObserveDom(resultContainer, refreshPrice);
        refreshPrice = null;
      });
    }

    if (window.dataLayer) {
      const refreshPriceDl = ({ message }) => {
        if (message.eventAction === 'select room') {
          thn.debounce(() => {
            thn.widgets.price.refresh();
          }, 500)();
        }
      };

      thn.bus.on('dataLayer:push', refreshPriceDl);

      thn.pageUnload(() => {
        thn.bus.detach('dataLayer:push', refreshPriceDl);
      });
    }
  };

  engine.boot = function boot() {
    const containerBooking = document.querySelector('.default__main');

    if (containerBooking) {
      const refreshPage = thn.debounce(thn.pageCheck, 400);

      thn.observeDom(containerBooking, refreshPage, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(containerBooking, refreshPage);
      });
    }
  };

  /**
        *
        * @memberOf module:bs_237
        *
        */
  engine._roomDetailsParseData = function roomDetailsParseData(adults, children, nights) {

    const roomElArray = [...document.querySelectorAll('.room')];

    if (thn.empty(roomElArray)) {
      return {};
    }

    const roomsInfo = roomElArray
      .map((room) => {
        const roomName = room.querySelector('.mcp-room-name')?.textContent?.trim();
        const roomType = getRoomType(roomName);
        const roomRates = [...room.querySelectorAll('.room-offer__property')]
          .map((rate) => {
            const rateName = rate.querySelector('.room-offer__title')?.textContent;
            const price = thn.parseNumber(rate.querySelector('.booking-price')?.innerText);
            const isRefundable = !!rateName?.match(/flexible/);
            const hasBreakfast = !!rateName?.match(/breakfast/);
            const infoRate = {
              id: '',
              name: rateName,
              totalNight: price / nights,
              breakfast: hasBreakfast,
              refundable: isRefundable,
            };

            return infoRate;
          });
        return {
          id: '',
          name: roomName,
          adults: thn.parseNumber(adults) || 2,
          children: thn.parseNumber(children) || 0,
          type: roomType,
          prices: roomRates,
        };

      }).filter(Boolean);

    return roomsInfo;

  };

  /**
     * @memberOf module:bs_237
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    // https://all.accor.com/ssr/app/sofitel/rates/0454/index.en.shtml?dateIn=2025-05-18&nights=13&compositions=1,1-3&stayplus=false&snu=false&accessibleRooms=false&hideWDR=false&hideHotelDetails=true&destination=

    const url = new URL(ctx.baseUrl);
    const validUrl = !!url.hostname.match(/accor/) && !!url.pathname.match(/rates/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }
    // Dates
    let nights = 1;
    const dateBegin = ctx.data.dateBegin;
    const dateEnd = ctx.data.dateEnd;
    if (dateBegin && dateEnd) {
      nights = thn.daysBetween(dateBegin, dateEnd);
    }
    url.searchParams.set('dateIn', '[date_begin]');
    url.searchParams.set('nights', nights);

    ctx.newData.dateBegin = ctx.data.dateBegin && ctx.data.dateBegin.replace(/\//g, '-');
    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_237
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v1 = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;

    if (!$) { return widgetData; }

    // Dates
    widgetData.dateBegin = ((window.location.hash.match(new RegExp('dateIn=([^&]*)')) || [])[1] || '').replace(/-/g, '/');
    const nights = parseInt((window.location.hash.match(new RegExp('nights=([^&]*)')) || [])[1], 10) || 1;
    widgetData.dateEnd = widgetData.dateBegin && thn.dateToString(thn.addDays(widgetData.dateBegin, nights));

    // Guests, Adults & Children
    widgetData.adults = parseInt((window.location.hash.match(new RegExp('adults=([^&]*)')) || [])[1], 10) || 2;
    widgetData.children = parseInt((window.location.hash.match(new RegExp('children=([^&]*)')) || [])[1], 10) || 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Prices & Currency || No Rooms can't be detected. When rooms are not available, the BE displays a message on the Calendar page
    const prices = $('.room-block__header__head-line__resume__offer__price.reborn-price').map((idx, price) => thn.parseNumber($(price).text())).toArray();

    if (prices.length) {
      widgetData.price = Math.min(...prices) / nights;
      widgetData.currency = thn.getCurrencyCode($('.currency-select select').val() || '');
      if (widgetData.price && widgetData.currency) {
        widgetData.set = true;
      }
    }

    return widgetData;
  };
  /**
     * @memberOf module:bs_237
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v2 = function priceParseData(ctx) {

    const widgetData = {};

    // Dates
    const dateBegin = thn.parseUrlParameter('dateIn')?.replace(/-/g, '/');
    const nights = thn.parseNumber(thn.parseUrlParameter('nights')) || 1;
    if (dateBegin && nights) {
      const dateEnd = thn.dateToString(thn.addDays(dateBegin, nights));
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
    }

    // Guests, Adults & Children
    const guestsArray = thn.parseUrlParameter('compositions')?.split(',');
    const roomNumber = thn.parseNumber(document.querySelector('.multiroom-stepper-item--active')?.textContent) || 1;
    const roomGuests = guestsArray?.[roomNumber - 1]?.split('-');
    const adults = thn.parseNumber(roomGuests[0]);
    const childrenAges = roomGuests.slice(1).map((age) => {
      const parsedAge = thn.parseNumber(age);
      return parsedAge === 0 ? 1 : parsedAge;
    });
    const children = childrenAges.length;
    const roomInfo = {
      adults,
      children,
      childrenAges,
    };
    widgetData.roomsDispo = [roomInfo];

    // Filter applied
    const isFilterApplied = [...document.querySelectorAll('.checkbox__input')].some((checkbox) => checkbox.checked);
    if (isFilterApplied) {
      widgetData.priceSpecial = 1;
    }

    // Prices & Currency
    const prices = [...document.querySelectorAll('.rate-details__price--default')].map((price) => thn.parseNumber(price?.innerText));
    const currency = thn.parseCurrency(document.querySelector('.js-currency-text')?.textContent);
    const noAvailability = !!document.querySelector('.rates__summary-notification');

    if (!thn.empty(prices) && currency && nights) {
      widgetData.price = Math.min(...prices) / nights;
      widgetData.currency = currency;
      widgetData.roomDetails = engine._roomDetailsParseData(widgetData.adults, widgetData.children, nights);
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_237
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {
    const $ = window.jQuery;

    // If booking data is not set yet
    if (!ctx.widget.isSet()) {
      const mainApp = $ && $('#app-main');
      if (mainApp && mainApp.length) {
        const observer = thn.debounce(function accorBookingObserver() {
          if ($('.basket-total__container__line__price--final .price:visible').length) {
            ctx.widget.logger.debug('Booking price displayed!');
            if (ctx.widget.setData().isSet()) {
              thn.stopObserveDom(mainApp.get(0), observer);
              ctx.widget.save();
            }
          }
        }, 400);

        thn.observeDom(mainApp.get(0), observer, {
          childList: true,
          subtree: true,
          characterData: false,
          attributes: true,
          attributeFilter: ['class'],
        });

        thn.pageUnload(function () {
          thn.stopObserveDom(mainApp.get(0), observer);
        });
      }
    }
  };

  /**
     * @memberOf module:bs_237
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const bookingData = thn.dataLayerHelper.get('ecommerce');

    // Booking ID
    const bookingId = document.querySelector('#reborn-confirmation-info-b2c-number')?.textContent || bookingData?.transaction_id;

    if (bookingId) {
      // Booking ID
      widgetData.bookingId = bookingId;

      // Dates
      const datesV1 = document.querySelector('.date-mention__dates')?.textContent?.match(/(\d+)\D+(\d+)\D+(\d+)/g);
      const dateBeginV1 = datesV1?.[0]?.replace(/-/g, '/');
      const dateEndV1 = datesV1?.[1]?.replace(/-/g, '/');
      const datesBeginV2 = translateDate(document.querySelector('.is-date-in span:nth-child(2)')?.innerText, thn.data.language);
      const datesEndV2 = translateDate(document.querySelector('.is-date-out span:nth-child(2)')?.innerText, thn.data.language);
      widgetData.dateBegin = dateBeginV1 || datesBeginV2;
      widgetData.dateEnd = dateEndV1 || datesEndV2;

      // Price & Currency
      const price = document.querySelector('.basket-total__container__line__price--final .price')?.textContent || bookingData?.value;
      const currency = thn.parseCurrency(price) || bookingData?.currency;
      widgetData.price = thn.parseNumber(price);
      widgetData.currency = currency;
    } else {
      widgetData.set = false;
    }

    return widgetData;
  };

  return engine;

}

export { factory };
